import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DefaultComponentsModule } from 'app/shared/modules/default-components.module';
import { AulaResponse } from 'app/shared/models/ei-models';
import { AulaProgressService, AulaService } from 'app/shared/services/edduca-imob';

// Tipagem local para incluir o flag de UI
type AulaView = AulaResponse & { concluida?: boolean };

@Component({
  selector: 'app-modulo-dashcards',
  imports: [DefaultComponentsModule],
  templateUrl: './modulo-dashcards.component.html',
  styleUrl: './modulo-dashcards.component.scss'
})
export class ModuloDashcardsComponent {
  moduloId!: number;
  aulas: AulaView[] = [];
  carregando = true;

  constructor(
    private route: ActivatedRoute,
    private aulaService: AulaService,
    private progressService: AulaProgressService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.moduloId = +this.route.snapshot.paramMap.get('id')!;
    this.carregarAulas();
  }

  private carregarAulas() {
    this.carregando = true;

    this.aulaService.listarPorModulo(this.moduloId).subscribe(aulas => {
      // ordena por ordemAula (se já não vier ordenado)
      const ordenadas = [...aulas].sort((a, b) => (a.ordemAula ?? 0) - (b.ordemAula ?? 0));
      this.aulas = ordenadas as AulaView[];

      // busca progresso em lote para marcar concluídas (silencioso: não ativa loader global)
      const ids = this.aulas.map(a => a.id);
      if (ids.length === 0) {
        this.carregando = false;
        return;
      }

      this.progressService.getMany(ids).subscribe(list => {
        const concluidas = new Set(list.filter(p => p.concluida).map(p => p.aulaId));
        this.aulas = this.aulas.map(a => ({ ...a, concluida: concluidas.has(a.id) }));
        this.carregando = false;
      }, _ => {
        // fallback: mesmo com erro no progresso, pelo menos mostra as aulas
        this.carregando = false;
      });
    }, _ => this.carregando = false);
  }

  abrirAula(aula: AulaResponse) {
    this.router.navigate(['/aula', aula.id]);
  }

  voltarAcademia() {
    this.router.navigate(['/academia-edduca/academia']);
  }

  // ===== Helpers para progresso =====
  getAulasConcluidas(): number {
    return this.aulas.filter(a => a.concluida).length;
  }

  getProgressoPercentual(): number {
    if (this.aulas.length === 0) return 0;
    return Math.round((this.getAulasConcluidas() / this.aulas.length) * 100);
  }
}